import Permission from './permission.entity';
import { SosGetResponse } from '../sos-response';
import UserSetting from '../user-settings/user-setting.entity';
import User from '../users/user.entity';

export interface PermissionGetResponse extends SosGetResponse {
	listed: {
		Permission: Permission[];
		UserSetting: UserSetting[];
		User: User[];
	};
}
